// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0fd36fde","455":"5e715649","977":"eb1baba0"}[chunkId] + ".chunk.js";
};